// "IS THIS PROJECT EXPORTING RIGHT NOW?" — the strip on a project card.
//
// Owner, 2026-10-25: "a percentage loader on personal page project card that also reports
// the percentage of project export going on if any, and a button to view info, that takes
// us to model file, and opens left drawer with active log and percentage".
//
// IT DRAWS NOTHING WHEN NOTHING IS RUNNING. A card is a dense place and a permanent
// "not exporting" line would be noise on every card forever.
//
// THE DATA IS NOT FETCHED HERE. The page asks once for every card it is drawing
// (api/projectModels.exportActivityFor) and passes each card its own entry. Twenty cards
// each polling for themselves is twenty requests for an answer that is usually "no".
import React from "react";
import { useHistory } from "react-router-dom";
import { Progress, Tooltip } from "antd";

const STAGE = { prepare: "Preparing", bank: "Reading the model", publish: "Building 3D" };
const eta = (s) => (s > 90 ? `~${Math.round(s / 60)} min left` : s ? `~${s} s left` : "");

export default function ProjectExportProgress({ projectId, info }) {
  const history = useHistory();
  if (!info || !info.busy) return null;

  const stage = STAGE[info.stage] || "Exporting";
  const label = [
    info.count > 1 ? `${info.count} files` : info.fileName,
    stage,
    eta(info.etaSeconds),
  ].filter(Boolean).join(" - ");

  return (
    <div className="project-export-progress mt-2">
      <div className="d-flex align-items-center justify-content-between" style={{ gap: 8 }}>
        <Tooltip title={label}>
          <small className="text-muted text-truncate" style={{ maxWidth: 180 }}>{label}</small>
        </Tooltip>
        <button
          type="button"
          className="integration-link-btn"
          onClick={(e) => {
            e.stopPropagation();
            // straight to the Models page of THIS project with the live drawer open -
            // the file is in the query too, so the right drawer can land on the row
            history.push(`/models?project=${projectId}&export=active${info.file ? `&file=${info.file}` : ""}`);
          }}
        >
          View info
        </button>
      </div>
      <Progress percent={info.percent} size="small" status="active" />
    </div>
  );
}
